import { useMutation } from "react-query";

import { chatRoomApi } from "@/react/api/chatRoomApi";

export const useChatRoomParticipant = (chatRoomUuid: any) =>
  useMutation({
    mutationFn: () => chatRoomApi.getChatRoomCurrentParticipant(chatRoomUuid),
    mutationKey: ["chatroom", "participant", chatRoomUuid],
  });
